// extracted by mini-css-extract-plugin
export default {"root":"GameHeaderView_root__wkXx6","endTurnList":"GameHeaderView_endTurnList__eBYGd"};